import React from "react";
import { Redirect } from "react-router-dom";

import { parse } from "cortex/ui/src/util/queryString";

interface RedirectViewProps {
  location: {
    search: string;
  };
}

export function RedirectView({ location: { search } }: RedirectViewProps) {
  const params = parse(search);
  const { to: pathname } = params;

  if (typeof pathname === "string" && pathname) {
    return <Redirect to={pathname} />;
  }

  console.error(
    'Error: Only redirect to this view with "to" parameter in ' +
      "query string.",
  );

  return <Redirect to="/404" />;
}
